import script from "./ServiceChargesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceChargesSection.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__